import { Link } from "react-router-dom";
import { formatEpoch } from "../utils/formatters.js";
import {
  getCampaignProgress,
  getCampaignStatusLabel,
  getStatusClassName,
} from "../utils/history.js";

export default function CampaignList({ campaigns, loading, error }) {
  if (error) {
    return <p className="cg-error-text">{error}</p>;
  }

  return (
    <div className="cg-campaign-list">
      {loading ? (
        <div className="cg-empty-state">Loading campaigns...</div>
      ) : campaigns.length ? (
        campaigns.map((campaign) => {
          const progress = getCampaignProgress(campaign);
          return (
          <article key={campaign.campaign_id} className="cg-campaign-card">
            <div className="cg-campaign-card-top">
              <Link className="cg-campaign-link" to={`/cologuard/campaigns/${campaign.campaign_id}`}>
                {campaign.campaign_designator}
              </Link>
              <span
                className={`cg-status-pill ${getStatusClassName(
                  campaign.campaign_status || "Available"
                )}`}
              >
                {getCampaignStatusLabel(campaign.campaign_status)}
              </span>
            </div>
            <p>{campaign.campaign_name}</p>
            <div className="cg-campaign-progress" aria-label={`${progress.percent}% ready`}>
              <div className="cg-campaign-progress-label">
                <span>{progress.completedCodes.toLocaleString()} of {progress.requested.toLocaleString()} codes</span>
                <strong>{progress.percent}%</strong>
              </div>
              <div className="cg-progress-track">
                <span style={{ width: `${progress.percent}%` }} />
              </div>
            </div>
            <div className="cg-campaign-card-meta">
              <span>{progress.completedCodes.toLocaleString()} ready</span>
              <span>{formatEpoch(campaign.created_at)}</span>
            </div>
            <Link className="cg-campaign-detail-link" to={`/cologuard/campaigns/${campaign.campaign_id}`}>
              View campaign details &rarr;
            </Link>
          </article>
          );
        })
      ) : (
        <div className="cg-empty-state">No campaign records found yet.</div>
      )}
    </div>
  );
}
